.ek{z-index:50;}